import { NavLink } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import BarChartIcon from '@material-ui/icons/BarChart';
import BuildIcon from '@material-ui/icons/Build';
import DashboardIcon from '@material-ui/icons/ViewModule';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import MailIcon from '@material-ui/icons/Mail';
import React, { Component } from 'react';
import Tooltip from 'fuse-ui/components/Tooltip';

import PropTypes from 'prop-types';

import { SIDE_NAV_WIDTH } from '../constants/ui-options';
import opacity from 'fuse-ui/theme/colors/opacity';

const styles = theme => ( {
    drawerDock: {
        height: '100vh',
    },
    drawerPaper: {
        backgroundColor: theme.palette.secondary.main,
        border: 'none',
        marginTop: SIDE_NAV_WIDTH,
        overflowX: 'hidden',
        position: 'fixed',
        whiteSpace: 'nowrap',
        width: SIDE_NAV_WIDTH,
    },
    list: {
        padding: 0
    },
    listItem: {
        '&.active': {
            '&>div': {
                color: theme.palette.secondary.contrastText
            },
            backgroundColor: theme.palette.secondary[900],
        },
        '&:hover': {
            '&>div': {
                color: theme.palette.secondary.contrastText
            },
        },
        backgroundColor: theme.palette.secondary[800],
        height: SIDE_NAV_WIDTH,
        paddingLeft: 14,
        paddingRight: 14,
    },
    listItemIcon: {
        color: opacity.white[70],
    },
} );


const iconMap = {
    barChart: BarChartIcon,
    build: BuildIcon,
    dashboard: DashboardIcon,
    mail: MailIcon,
};

class SideNav extends Component{
    handleOnClick = ( index, id ) => ( e ) => {
        this.props.switchSideNavItems( id );
    }
    render(){
        const { classes, sideNavItems, isExperimental } = this.props;
        return (
            <div className="no-print">
                <Drawer
                    variant="permanent"
                    classes={{
                        docked: classes.drawerDock,
                        paper: classes.drawerPaper,
                    }}
                    open={false}
                >
                    <List className={classes.list}>
                        {
                            sideNavItems
                                .filter( ( item ) => isExperimental || Boolean( item.isExperimental ) === false )
                                .sort( ( item1, item2 ) => ( item1.order - item2.order ) )
                                .map( ( item, index ) => {
                                    const Icon = iconMap[item.icon] || DashboardIcon;
                                    const url = item.base ? `${item.base}${item.url}` : item.url;
                                    const canvasName = item.label;

                                    return (
                                        <Tooltip title={canvasName} key={url} placement="left">
                                            <ListItem
                                                button={true}
                                                classes={{ root: classes.listItem }}
                                                component={NavLink}
                                                data-automation-id={`navigation-${item.label}`}
                                                onClick={this.handleOnClick( index, item.id )}
                                                to={url}
                                            >
                                                <ListItemIcon className={classes.listItemIcon}>
                                                    {<Icon style={{ fontSize: 24 }} />}
                                                </ListItemIcon>
                                                <ListItemText primary={item.label} />
                                            </ListItem>
                                        </Tooltip>

                                    );
                                } )
                        }
                    </List>
                </Drawer>
            </div>
        );
    }
}

SideNav.propTypes = {
    classes: PropTypes.object.isRequired,
    isExperimental: PropTypes.bool,
    sideNavItems: PropTypes.array,
    switchSideNavItems: PropTypes.func.isRequired,
    theme: PropTypes.object.isRequired,
};

SideNav.defaultProps = {
    sideNavItems: [],
};

export default withStyles( styles, { withTheme: true } )( SideNav );
